"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderCancellationInfoToString = exports.CANCELED_BY_PARTNER_API_CANCELLATION_INFO = exports.CANCELED_BY_CUSTOMER_CANCELLATION_INFO = exports.ORDER_CANCELLATION_REASONS = exports.ORDER_CANCELLATION_CATEGORIES = void 0;
const CANCELLATION_CATEGORIES = ["Customer", "Driver", "Support"];
exports.ORDER_CANCELLATION_CATEGORIES = CANCELLATION_CATEGORIES;
exports.ORDER_CANCELLATION_REASONS = {
    Customer: [
        "Connection issue (flight, train, ship, etc.)",
        "Booked somewhere else",
        "No-show",
        "Upset with Daytrip about another trip",
        "Price change",
        "Flexible / super flexible cancellation",
        "Medical",
        "Force majeure",
        "Other",
    ],
    Driver: [
        "No-show",
        "Late pick up",
        "Different driver sent",
        "Different vehicle",
        "Last minute change not accepted",
        "Mechanical issue",
        "Other",
    ],
    Support: [
        "Mistake",
        "Wrong quote provided",
        "Other",
    ],
};
exports.CANCELED_BY_CUSTOMER_CANCELLATION_INFO = {
    category: "Customer",
    reason: "Other",
    note: "Cancelled by the customer via the customer interface",
};
exports.CANCELED_BY_PARTNER_API_CANCELLATION_INFO = {
    category: "Customer",
    reason: "Other",
    note: "Cancelled by the customer via the partner API",
};
const orderCancellationInfoToString = (info) => {
    return `${info.category}: ${info.reason}`;
};
exports.orderCancellationInfoToString = orderCancellationInfoToString;
//# sourceMappingURL=OrderCancellationInfo.js.map